import { Signal } from "@lit-labs/signals";
import type { Community } from "api-contracts/rpc/community";
import type { SortState } from "ui-components/wow-base-table/types";
import { sortItems } from "ui-components/wow-base-table/sort-utils";
import type { SortEntry } from "ui-components/wow-base-table/sort-types";
import type { IWritableCreatorCommunitiesState, ICreatorCommunitiesState, CommunityCounts } from "./types";

const DEFAULT_COUNTS: CommunityCounts = { draft: 0, published: 0, archived: 0, total: 0 };

export class CreatorCommunitiesState implements IWritableCreatorCommunitiesState {
  readonly communities = new Signal.State<Community[]>([]);
  readonly isLoading = new Signal.State<boolean>(false);
  readonly errorMessage = new Signal.State<string>("");
  readonly activeSorts = new Signal.State<SortEntry[]>([]);
  readonly counts = new Signal.State<CommunityCounts>({ ...DEFAULT_COUNTS });
  readonly totalUniqueMembers = new Signal.State<number>(0);

  get primarySortState(): SortState {
    const first = this.activeSorts.get()[0];
    if (!first) return { column: null, direction: "none" };
    return { column: first.column, direction: first.direction };
  }

  getSortedItems(items: Community[]): Community[] {
    return sortItems(items, this.activeSorts.get());
  }
}

export function asReadonlyCreatorCommunitiesState(state: CreatorCommunitiesState): ICreatorCommunitiesState {
  return state as ICreatorCommunitiesState;
}
